<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                 <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item" aria-current="page">
                        <router-link to="/dashboard">Dashboard</router-link></li>
                        <li class="breadcrumb-item" aria-current="page">
                        <router-link to="/users">Users</router-link></li>
                    <li class="breadcrumb-item " aria-current="page" v-if="status">New User</li>
                    <li class="breadcrumb-item active" aria-current="page" v-else>Update User</li>
                </ol>
                <h4 class="main-title mb-0">Users</h4>
            </div>
            <router-link to="/users" type="submit" class="btn btn-primary d-flex align-items-center gap-2" >
                <i class="ri-list-check fs-18 lh-1"></i>Users
            </router-link>
        </div>
        <div class="row">
            <div class="col-12">
                <form @submit.prevent="submitForm">
                    <div class="card card-one">
                        <div class="card-header d-flex justify-content-between">
                            <h6 class="card-title" v-if="status">New User</h6>
                            <h6 class="card-title" v-else>Update User</h6>
                        </div>
                        <div class="card-body ">
                            <div class="row g-2">
                                <div class="col-md-3" v-if="status">
                                    <label class="form-label">Name</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Name" class="form-control" :class="{'is-invalid':errors.name}" v-model="user.name" ref="name" />
                                    <span v-if="errors.name" class="invalid-feedback">{{ errors.name[0] }}</span>
                                </div>
                                <div class="col-md-4" v-else>
                                    <label class="form-label">Name</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Name" class="form-control" :class="{'is-invalid':errors.name}" v-model="user.name" ref="name" />
                                    <span v-if="errors.name" class="invalid-feedback">{{ errors.name[0] }}</span>
                                </div>
                                <div class="col-md-3" v-if="status">
                                    <label class="form-label">Username</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Username" class="form-control" :class="{'is-invalid':errors.username}" v-model="user.username" />
                                    <span v-if="errors.username" class="invalid-feedback">{{ errors.username[0] }}</span>
                                </div>
                                <div class="col-md-4" v-else>
                                    <label class="form-label">Username</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Username" class="form-control" :class="{'is-invalid':errors.username}" v-model="user.username" />
                                    <span v-if="errors.username" class="invalid-feedback">{{ errors.username[0] }}</span>
                                </div>
                                <div class="col-md-3" v-if="status">
                                    <label class="form-label">Email</label><span class="text-danger"> *</span>
                                    <input type="email" placeholder="Email" class="form-control" :class="{'is-invalid':errors.email}" v-model="user.email" />
                                    <span v-if="errors.email" class="invalid-feedback">{{ errors.email[0] }}</span>
                                </div>
                                <div class="col-md-4" v-else>
                                    <label class="form-label">Email</label><span class="text-danger"> *</span>
                                    <input type="email" placeholder="Email" class="form-control" :class="{'is-invalid':errors.email}" v-model="user.email" />
                                    <span v-if="errors.email" class="invalid-feedback">{{ errors.email[0] }}</span>
                                </div>
                                
                               <div class="col-md-3" v-if="status">
                                    <label class="form-label">Password</label><span class="text-danger"> *</span>
                                    <input type="password" :disabled="!status" placeholder="Password" class="form-control" :class="{'is-invalid':errors.password}" v-model="user.password" />
                                    <span v-if="errors.password" class="invalid-feedback">{{ errors.password[0] }}</span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Role</label><span class="text-danger"> *</span>
                                    <select class="form-control" :class="{ 'is-invalid': errors.role_id }" v-model="user.role_id">
                                        <option value="">Select Role</option>
                                        <option v-for="role, key in roles" :key="key" :value="role.role_id"> {{ role.role_name }}</option>
                                    </select>
                                    <span v-if="errors.role_id" class="invalid-feedback">{{ errors.role_id[0] }}</span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Plant</label><span class="text-danger"> *</span>
                                    <input type="text" class="form-control" :value="$store.getters.user?.plant?.plant_name" readonly>
                                    <!-- <select class="form-control" :class="{ 'is-invalid': errors.plant_id }" v-model="user.plant_id">
                                        <option value="">Select Plant</option>
                                        <option v-for="plant, key in plants" :key="key" :value="plant.plant_id"> {{ plant.plant_name }}</option>
                                    </select> -->
                                    <!-- <search
                                        :class="{ 'is-invalid': errors.plant_id }"
                                        :customClass="{ 'is-invalid': errors.plant_id }"
                                        :initialize="user.plant_id"
                                        id="plant_id"
                                        label="plant_name"
                                        placeholder="Select Plant"
                                        :data=" plants" 
                                        @input="selectPlant($event)"
                                    >
                                    </search> -->
                                    <span v-if="errors.plant_id" class="invalid-feedback">{{ errors.plant_id[0] }}</span>
                                </div>

                                <div class="col-md-4">
                                    <label class="form-label">Mobile No.</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Mobile No." class="form-control" :class="{ 'is-invalid': errors.mobile_no }" v-model="user.mobile_no" />
                                    <span v-if="errors.mobile_no" class="invalid-feedback">{{ errors.mobile_no[0] }}</span>
                                </div>
                                <div class="col-md-12">
                                    <label class="form-label">Address</label>
                                    <textarea type="text" placeholder="Address" class="form-control" :class="{ 'is-invalid': errors.address }" v-model="user.address"></textarea>
                                    <span v-if="errors.address" class="invalid-feedback">{{ errors.address[0] }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-end">
                            <button type="button" class="btn btn-danger me-2" @click.prevent="discard()"><i class="ri-close-line fs-18 lh-1"></i> Back</button>
                            <button type="submit" class="btn  btn-primary" >
                                <span v-if="status"><i class="ri-save-line fs-18 lh-1"></i> Submit</span>
                                <span v-else><i class="ri-save-line fs-18 lh-1"></i> Update</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
 import Search from "@/components/Search.vue";
    export default {
        components: {
            Search,
        },
        name: "Users.Create",
        data() {
            return {
                user: {
                    user_id: "",
                    name: "",
                    username: "",
                    email: "",
                    password: "",
                    mobile_no: "",
                    role_id: "",
                    plant_id: "",
                    address: "",
                    // avatar:'',
                },
                // plant:{
                //     plant_id:this.$store?.getters?.user?.plant?.plant_id,
                // },
                roles: [],
                plants: [],
                errors: [],
                status: true,
            };
        },

        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.getRoles();
                if (to.name == "Users.Create") {
                    vm.$refs.name.focus();
                } else {
                    vm.status = false;
                    let uri = { uri: "getUser", data: { user_id: to.params.user_id } };
                    vm.$store
                        .dispatch("post", uri)
                        .then(function (response) {
                            vm.user = response.data.data;
                            // vm.user.avatar = vm.$store.getters.assetUrl+'/users/'+vm.user.avatar
                        })
                        .catch(function (error) {
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
                vm.user.plant_id = vm.$store.getters.user?.plant?.plant_id
            });
        },
        methods: {
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.create();
                } else {
                    vm.update();
                }
            },
            selectPlant(e){
                this.user.plant_id = e;
            },
            getRoles() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getRoles" })
                    .then((response) => {
                        loader.hide();
                        vm.roles = response.data;
                        vm.getPlants();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            getPlants() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getPlants" })
                    .then((response) => {
                        loader.hide();
                        vm.plants = response.data.data;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            create() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "addUser", data: vm.user })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.$router.push("/users");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            update() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "updateUser", data: vm.user })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.$router.push("/users");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            discard() {
                let vm = this;
                vm.user.name = "";
                vm.user.username = "";
                vm.user.email = "";
                vm.user.password = "";
                vm.user.mobile_no = "";
                vm.user.address = "";
                vm.user.role_id = "";
                vm.user.plant_id = "";
                vm.$refs.name.focus();
                vm.errors = [];
                vm.status = true;
            },
            // onImageChange(e) {
            //     e.preventDefault();
            //     let vm = this;
            //     let image = e.target.files[0]; 
            //     let reader = new FileReader();
            //     reader.readAsDataURL(image);
            //     reader.onload = (e) => {
            //     vm.user.avatar = e.target.result;
				
            //     };
            // },
        },
    };
</script>
